import React, { useState, useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import { auth, db } from './firebase'; 
import { doc, getDoc, setDoc } from 'firebase/firestore'; 
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { Toaster } from 'react-hot-toast';

// Tus componentes
import LoginScreen from './LoginScreen';
import PublicBookingView from './PublicBookingView';

// Vistas del Panel
import ClientesView from './ClientesView';
import ProyectosEnTransitoView from './ProyectosEnTransitoView';
import CalendarioView from './CalendarioView'; 
import DashboardView from './DashboardView'; 
import ComprasView from './ComprasView';
import ReportesView from './ReportesView';
import Notifications from './Notifications';
import ConfiguracionView from './ConfiguracionView';
import SeguimientoView from './SeguimientoView';
import PresupuestosView from './PresupuestosView'; 

// 🔥 NUEVO: Importamos el Mostrador / TPV 🔥
import MostradorView from './MostradorView';

// Importamos el nuevo centro de operaciones financieras
import CentroOperaciones from './components/finanzas/CentroOperaciones';

// Importamos los nuevos componentes de asistencia QR
import AsistenciaAdminView from './AsistenciaAdminView';
import FichajeMovilView from './FichajeMovilView';

// Importamos la VISTA MAESTRA UNIFICADA de Inventario
import InventarioView from './InventarioView';

// Iconos
import { FaBars } from 'react-icons/fa'; 
import miLogo from './assets/mi-logo.png';

function PannelDeControl({ usuario }) { 
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [activeView, setActiveView] = useState('dashboard');
    const [navigationTarget, setNavigationTarget] = useState(null);

    const handleLogout = () => { signOut(auth).catch((error) => console.error("Error:", error)); };

    const handleNavigate = (target) => {
        setActiveView(target.view);
        setNavigationTarget(target.data);
    };

    // MENÚ DE NAVEGACIÓN
    const allNavigationItems = {
        dashboard: { label: 'Inicio', component: <DashboardView setActiveView={setActiveView} /> },
        agendarCita: { label: 'Agenda', component: <CalendarioView usuario={usuario} /> }, 
        clientes: { label: 'Familias', component: <ClientesView /> },
        seguimiento: { label: 'Solicitudes', component: <SeguimientoView /> },
        proyectos: { label: 'Eventos', component: <ProyectosEnTransitoView usuario={usuario} navigationTarget={navigationTarget} onNavigationComplete={() => setNavigationTarget(null)} /> },
        presupuestos: { label: 'Cotizaciones', component: <PresupuestosView usuario={usuario} /> },
        mostrador: { label: 'Caja / TPV', component: <MostradorView /> }, // ⬅️ NUEVO MÓDULO DE CAJA
        centroOperaciones: { label: 'Finanzas', component: <CentroOperaciones /> },
        compras: { label: 'Compras', component: <ComprasView /> },
        inventario: { label: 'Almacén', component: <InventarioView /> }, 
        reportes: { label: 'Métricas', component: <ReportesView /> },
        asistencia: { label: 'Staff', component: <AsistenciaAdminView /> },
        configuracion: { label: 'Ajustes', component: <ConfiguracionView usuario={usuario} /> },
    };
    
    // PERMISOS ACTUALIZADOS
    const permissions = {
        admin: ['dashboard', 'agendarCita', 'clientes', 'seguimiento', 'proyectos', 'presupuestos', 'mostrador', 'centroOperaciones', 'compras', 'inventario', 'reportes', 'asistencia', 'configuracion'],
        editor: ['dashboard', 'agendarCita', 'clientes', 'seguimiento', 'proyectos', 'presupuestos', 'mostrador', 'centroOperaciones', 'compras', 'inventario', 'reportes', 'asistencia'],
        vendedor: ['dashboard', 'agendarCita', 'clientes', 'seguimiento', 'proyectos', 'presupuestos', 'mostrador'],
        operario: ['proyectos', 'agendarCita'],
    };

    const userRole = usuario?.role?.trim() || 'operario';
    const allowedKeys = permissions[userRole] || [];
    const navigationItems = allowedKeys.reduce((acc, key) => {
        if (allNavigationItems[key]) { acc[key] = allNavigationItems[key]; }
        return acc;
    }, {});
    
    const renderActiveSection = () => {
        const currentItem = navigationItems[activeView];
        if (!currentItem) {
            const defaultViewKey = allowedKeys[0] || 'dashboard';
            if (activeView !== defaultViewKey) setActiveView(defaultViewKey);
            return navigationItems[defaultViewKey]?.component || <p className="p-4 text-center text-gray-500">No tienes acceso.</p>;
        }
        return currentItem.component;
    };
    
    const activeViewTitle = navigationItems[activeView]?.label || 'Panel de Control';

    return (
        <div className="flex h-screen bg-gray-50 font-sans overflow-hidden">
            <nav className={`absolute z-30 lg:relative w-64 bg-white border-r border-gray-200 text-kokimiko-texto flex flex-col p-4 shadow-lg h-full transform transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} lg:translate-x-0`}>
                <div className="flex flex-col items-center text-center mb-10 pt-4">
                    <img src={usuario.photoURL || miLogo} alt="Logo" className="w-full h-auto px-2 mb-4 object-contain" />
                    
                    <span className="text-xl font-bold text-kokimiko-texto">{usuario.name || usuario.displayName || 'Kokimiko'}</span>
                    <span className={`text-xs font-semibold mt-2 px-3 py-1 rounded-full uppercase bg-kokimiko-teal text-white shadow-sm`}>
                        {usuario.role}
                    </span>
                </div>
                <ul className="flex flex-col space-y-2 flex-1 overflow-y-auto custom-scrollbar">
                    {Object.keys(navigationItems).map((key) => {
                        const item = navigationItems[key];
                        const isActive = activeView === key;
                        return (
                            <li key={key}>
                                <button onClick={() => { setActiveView(key); setSidebarOpen(false); }} className={`w-full flex justify-center items-center px-4 py-3 rounded-lg transition-all duration-200 text-center ${isActive ? 'bg-kokimiko-azul text-white font-semibold shadow-md' : 'text-gray-600 hover:bg-kokimiko-fondo hover:text-kokimiko-azul'}`}>
                                    <span className="font-medium">{item.label}</span>
                                </button>
                            </li>
                        );
                    })}
                </ul>
                <div className="mt-auto">
                    <button onClick={handleLogout} className="w-full flex justify-center items-center mt-2 px-4 py-3 bg-kokimiko-naranja hover:opacity-80 rounded-lg transition-all duration-200 text-white shadow-md text-center">
                        <span className="font-medium">Salir</span>
                    </button>
                </div>
            </nav>
            <div className={`fixed inset-0 bg-black opacity-50 z-20 lg:hidden ${isSidebarOpen ? 'block' : 'hidden'}`} onClick={() => setSidebarOpen(false)}></div>
            <div className="flex-1 flex flex-col min-w-0">
                <header className="bg-white shadow-sm p-4 flex justify-between items-center z-10 border-b border-gray-200">
                    <div className="flex items-center">
                        <button onClick={() => setSidebarOpen(true)} className="text-kokimiko-texto lg:hidden mr-4"><FaBars size={24} /></button>
                        <h1 className="text-2xl font-bold text-kokimiko-texto">{activeViewTitle}</h1>
                    </div>
                    <Notifications />
                </header>
                <main className="flex-1 overflow-y-auto bg-kokimiko-fondo/30">{renderActiveSection()}</main>
            </div>
        </div>
    );
}

function App() {
    const [usuario, setUsuario] = useState(null);
    const [cargando, setCargando] = useState(true);

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, async (userAuth) => {
            if (userAuth) {
                const userDocRef = doc(db, 'users', userAuth.uid);
                const userDocSnap = await getDoc(userDocRef);
                if (userDocSnap.exists()) {
                    setUsuario({ uid: userAuth.uid, photoURL: userAuth.photoURL, ...userDocSnap.data() });
                } else {
                    const newUserProfile = { email: userAuth.email, displayName: userAuth.displayName || userAuth.email.split('@')[0], role: 'admin' };
                    await setDoc(userDocRef, newUserProfile);
                    setUsuario({ uid: userAuth.uid, photoURL: userAuth.photoURL, ...newUserProfile });
                }
            } else { setUsuario(null); }
            setCargando(false);
        });
        return unsubscribe;
    }, []);

    if (cargando) return <div className="flex justify-center items-center h-screen bg-kokimiko-fondo"><h2 className="text-2xl font-bold text-kokimiko-texto animate-pulse">Cargando Kokimiko...</h2></div>;

    return (
        <div>
            <Toaster position="top-center" />
            <Routes>
                <Route path="/reserva" element={<PublicBookingView />} />
                <Route path="/fichaje" element={<FichajeMovilView />} />
                <Route path="/*" element={usuario ? <PannelDeControl usuario={usuario} /> : <LoginScreen />} />
            </Routes>
        </div>
    );
}

export default App;